import gql from 'graphql-tag';

export default gql`
  fragment mailCampaignBlockTextFragment on MailCampaignBlockText {
    id
    textHtml
    plainText
    bodyColor
    textColor
    paddingTop
    paddingBottom
    paddingLeft
    paddingRight
    lineHeight
    createdAt
    updatedAt
  }
`;
